$ = require 'jquery'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
Auth = require 'app/scripts/db/auth'
template = require 'app/scripts/views/templates/header_enterprise_license'
{ track } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'

module.exports = class EnterpriseLicenseBannerView extends WarningBannerView
  className: Util.extendParentClassName('enterprise-license-banner')

  events:
    'click .js-dismiss-enterprise-license-banner': 'dismiss'

  render: ->
    data =
      enterpriseName: @model.displayName
      maxMembers: @model.seats.max
      availableLicenses: @model.seats.available
    @$el.html template(data)

    @

  dismiss: (e) ->
    track("Header", "Enterprise License Banner", "Dismiss")
    Auth.me().dismissEnterpriseBannerFor @model.idEnterprise
    $(e.target).closest('.enterprise-license-banner').remove()
    e.preventDefault()
